// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { SendingEventExt } from './models/SendingEventExt';

export const SendingEventExtSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const SendingEventExtStore = types
  .compose(
    getBaseStore<Instance<typeof SendingEventExt>, Instance<typeof SendingEventExt>>(SendingEventExt, 'SendingEventId', 'SendingEvent'),
    types.model('SendingEventExtStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const updateSendingEventExtInStore = (se: Instance<typeof SendingEventExt>) => {
      const seModel = SendingEventExt.create(se);
      self.datas.put(seModel);
      return seModel;
    };

    const searchSendingEventExt =  flow(function*(criteria: Instance<typeof SendingEventExtSearch>) {
      const result = yield apiFetcher.get('message/history', {
        params: criteria,
      });
      const resultSe: Array<Instance<typeof SendingEventExt>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdSe = updateSendingEventExtInStore(node);
        resultSe.push(createdSe);
      });
      return resultSe;
    });

    return { searchSendingEventExt };
  });

export type SendingEventExtStoreType = Instance<typeof SendingEventExtStore>;
